export const FETCH_CLAIM_REPORTS_REQUEST = 'FETCH_CLAIM_REPORTS_REQUEST';
export const FETCH_CLAIM_REPORTS_SUCCESS = 'FETCH_CLAIM_REPORTS_SUCCESS';
export const FETCH_CLAIM_REPORTS_FAILURE = 'FETCH_CLAIM_REPORTS_FAILURE';
